import { Box, Grid } from "@mui/material";

import { useThemedBrandingColor } from "./useThemedBrandingColor";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormTypography } from "@/forms-design-system/FormTypography";

type ThemedPoweredByZeffyProps = {
  link?: {
    href: string;
    amplitudeEvent?: { event: AmplitudeEvents; properties?: Record<string, unknown> };
  };
  slots: {
    logo: React.ReactNode;
  };
};

export const ThemedPoweredByZeffy = ({ link, slots }: ThemedPoweredByZeffyProps) => {
  const { t } = useTranslate();
  const poweredByColor = useThemedBrandingColor();
  const { logAmplitudeEventCallback } = useAmplitude();

  const handleClick = link?.amplitudeEvent
    ? logAmplitudeEventCallback(link.amplitudeEvent.event, link.amplitudeEvent.properties)
    : undefined;

  const content = (
    <Grid
      item
      container
      alignItems="center"
      justifyContent="center"
      gap={1}
      sx={(theme) => ({
        display: "flex",
        marginBottom: theme.spacing(1),
        width: "auto",
      })}
    >
      <Grid item ml={1}>
        <FormTypography variant="h6" vibe="moderate" color={poweredByColor} sx={{ fontStyle: "italic" }}>
          {t("common", "thankYouPage.poweredBy")}
        </FormTypography>
      </Grid>
      <Grid item mr={1} display="flex" alignItems="center" height="100%">
        {slots.logo}
      </Grid>
    </Grid>
  );

  if (link) {
    return (
      <Box
        component="a"
        href={link.href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        sx={{
          textDecoration: "none",
          color: "inherit",
          cursor: "pointer",
          "&:hover": { opacity: 0.8 },
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
};
